import { NgModule } from '@angular/core';
import { NgxWebAppComponent } from './ngx-web-app.component';
import { RouterModule, Routes } from '@angular/router';
const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./modules/web-builder-home/web-builder-home.module').then(m => m.WebBuilderHomeModule),
    }];
@NgModule({
    declarations: [
        NgxWebAppComponent,
    ],
    imports:[
        RouterModule.forChild(routes),
    ],
    exports: [
        NgxWebAppComponent
    ],
        
})
export class NgxWebAppModule { }
